import { render, staticRenderFns } from "./showMessageDialog.vue?vue&type=template&id=2e660634&"
import script from "./showMessageDialog.vue?vue&type=script&lang=js&"
export * from "./showMessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./showMessageDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e660634')) {
      api.createRecord('2e660634', component.options)
    } else {
      api.reload('2e660634', component.options)
    }
    module.hot.accept("./showMessageDialog.vue?vue&type=template&id=2e660634&", function () {
      api.rerender('2e660634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/SharedCenter/showMessageDialog.vue"
export default component.exports